import React from "react";
import { IProjectState } from "../../interfaces/IProjectState";
import { IUserSmall } from "../../interfaces/IUser";
import { IWorkerRate } from "../../interfaces/IWorkerRate";
import { Box, Card, CardContent, Grid, IconButton, Typography, useTheme } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { ProjectDistributionChart } from "./ProjectDistributionChart";
import { IChartData } from "./SalesDasboard";

interface IProps {
    currentUserSamll?: IUserSmall;
    workerRareArray: IWorkerRate[];
    projectStateArray: IProjectState[];
    fromDate: Date | null;
    toDate: Date | null;
    onHide?: () => void;
}

export const SalesBoardUserNew: React.FC<IProps> = ({
    currentUserSamll,
    workerRareArray,
    projectStateArray,
    fromDate,
    toDate,
    onHide,
}) => {
    const theme = useTheme();

    const currentRate = workerRareArray.find((rate) => rate.id === currentUserSamll?.profile?.id);

    const chartData = (): IChartData[] => {
        if (currentRate) {
            return projectStateArray.map((state) => {
                let currentStatRate = currentRate!.ProjectStateRates.find(
                    (proStateRate) => proStateRate.id === state.id,
                );
                if (currentStatRate) {
                    return { name: `${state.projectState}`, value: currentStatRate.results } as IChartData;
                } else {
                    return { name: `FEHLER ${state.projectState}`, value: 0 } as IChartData;
                }
            });
        } else {
            return [];
        }
    };

    if (!currentRate) {
        return <>Fehler!</>;
    }

    return (
        <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Card variant="outlined" sx={{ position: "relative" }}>
                {onHide && (
                    <IconButton size="small" onClick={onHide} sx={{ position: "absolute", top: 4, right: 4 }}>
                        <GridCloseIcon fontSize="small" />
                    </IconButton>
                )}

                <CardContent>
                    <Typography variant="h4">
                        {currentUserSamll == undefined
                            ? "FEHLER!"
                            : `${currentUserSamll.first_name} ${currentUserSamll.last_name}`}
                    </Typography>

                    {(currentUserSamll === undefined ||
                        currentUserSamll.id === 0 ||
                        [3, 4].indexOf(Number(currentUserSamll.profile?.Role)) > -1) && (
                        <>
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                Conversion Rate
                            </Typography>
                            <Box sx={{ display: "flex" }}>
                                <Typography sx={{ ml: 10 }} variant="h4">
                                    {currentRate.conversionRate
                                        ? currentRate.conversionRate.toFixed(2).replace(".", ",") + " %"
                                        : "0,00 %"}
                                </Typography>
                            </Box>
                        </>
                    )}

                    {(currentUserSamll === undefined ||
                        currentUserSamll.id === 0 ||
                        [1, 5, 6].indexOf(Number(currentUserSamll.profile?.Role)) > -1) && (
                        <>
                            <Typography variant="h6" sx={{ mt: 2 }}>
                                Abschlussquote
                            </Typography>
                            <Box sx={{ display: "flex" }}>
                                <Typography sx={{ ml: 10 }} variant="h4">
                                    {currentRate.closingRate
                                        ? currentRate.closingRate.toFixed(2).replace(".", ",") + " %"
                                        : "0,00 %"}
                                </Typography>
                            </Box>
                        </>
                    )}

                    <ProjectDistributionChart chartData={chartData()} />
                </CardContent>
            </Card>
        </Grid>
    );
};
